import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbModal, NgbPaginationConfig} from '@ng-bootstrap/ng-bootstrap';
import {AlertService} from '../../shared/services/alert.service';
import {FileService} from '../../shared/services/file.service';
import {ProfileService} from '../../shared/services/profile.service';
import {UserService} from '../../shared/services/user.service';
import {Router} from '@angular/router';
import {StorageService} from '../../shared/services/storage.service';
import {ImageCroppedEvent} from 'ngx-image-cropper';
import {AppConstants} from '../../shared/constants/app-constant';
import {DataService} from '../../shared/services/data.service';
import {StateService} from '../../shared/services/state.service';

@Component({
    selector: 'app-my-profile',
    templateUrl: './my-profile.component.html',
    styleUrls: ['./my-profile.component.scss']
})
export class MyProfileComponent implements OnInit {
    addProfileForm: FormGroup;
    imageChangedEvent: any;
    croppedImage: any;
    croppedImageEvent: any;
    states = [];
    profileImageUploadArea: any = 'assets/images/image-backgrounds/200-200.png';
    profileImage: any;
    profilePasswordForm: FormGroup;
    submitted: any = false;
    inputTypePasswordOld: any = 'password';
    inputTypePasswordNew: any = 'password';
    inputTypePasswordConfirm: any = 'password';
    imageBaseUrl: any = AppConstants.BUCKET_URL;
    responseUpdatePassword: any;
    @ViewChild('content') templateRef: TemplateRef<any>;
    updatePasswordOtpForm: FormGroup;
    submittedOtp: any = false;
    submittingOtp: any = false;
    constructor(config: NgbPaginationConfig,
                private modalService: NgbModal,
                private alertService: AlertService,
                private fileService: FileService,
                private profileService: ProfileService,
                private stateService: StateService,
                private userService: UserService,
                private router: Router,
                private dataService: DataService,
                private fb: FormBuilder) {
        config.size = 'sm';
        config.boundaryLinks = true;
    }

    modalType: any;
    user: any;

    ngOnInit(): void {
        this.user = StorageService.getItem('self');
        this.refresh();
    }

    refresh() {
        this.updatePasswordOtpForm = this.fb.group({
            otp: ['', [Validators.required]]
        });
        this.profilePasswordForm = this.fb.group({
            'current_password': ['', Validators.required],
            'new_password': ['', Validators.required],
            'confirm_password': ['', Validators.required],
        });
        this.addProfileForm = this.fb.group({
            name: ['', Validators.required],
            username: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            contact: ['', Validators.required],
            address: ['', Validators.required],
            city: ['', Validators.required],
            pin_code: ['', Validators.required],
            state_id: ['', Validators.required],
            gst_no: ['', [Validators.pattern(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}[Z]{1}[A-Z0-9]{1}$/)]],
        });
        this.getState();
        this.getDetail();
    }

    update() {
        this.alertService.showSuccess({title: 'Success', message: 'Profile updated successfully'});
    }

    openLg(content) {
        this.modalType = 'PASSWORD';
        this.modalService.open(content, {size: 'md'});
    }

    imageCropped(event: ImageCroppedEvent) {
        this.croppedImage = event.base64;
        this.croppedImageEvent = event;
    }

    imageLoaded() {
        // show cropper
    }

    cropperReady() {
        // cropper ready
    }

    loadImageFailed() {
        // show message
    }

    onImageChange(e) {
        this.imageChangedEvent = e;
    }

    openProfileModel(content) {
        this.modalType = 'PROFILE_IMAGE';
        this.modalService.open(content);
    }

    saveProfileImage() {
        const params = {
            'type': 'PROFILE_IMAGE',
            'user_id': this.user.user_id,
            'fileType': 'BASE64'
        };
        this.fileService.fileUpload(params, this.croppedImage).subscribe(data => {
            if (data) {
                this.modalService.dismissAll('');
                this.imageChangedEvent = undefined;
                this.updateProfileImage({'user_id': this.user.userId, 'profile_id': data['data'].id});
            }
        });
    }

    updateProfileImage(data) {
        this.profileService.updateProfile(this.user.userId, data).subscribe(data => {
            this.getDetail();
        });
    }




    getDetail() {
        this.userService.selfDetail().subscribe(data => {
            if (data && data['user'] && data['user']['profile'] && data['user']['profile'].partial_url) {
                this.profileImage = this.imageBaseUrl + data['user']['profile'].partial_url;
                this.dataService.sendMessage('PROFILE_IMAGE');
            }
            this.addProfileForm.patchValue({
                name: (data && data.name) ? data.name : '',
                username: (data && data.username) ? data.username : '',
                email: (data && data.email) ? data.email : '',
                contact: (data && data.contact) ? data.contact : '',
                address: (data && data.address) ? data.address : '',
                city: (data && data.city) ? data.city : '',
                pin_code: (data && data.pin_code) ? data.pin_code : '',
                state_id: (data && data.state_id) ? data.state_id : '',
                gst_no: (data && data.gst_no) ? data.gst_no : '',
            });
        });

    }
    getState() {
        this.stateService.get().subscribe(data => {
            if (data && data['data'].length > 0) {
                this.states = data['data'];
            }
        });
    }


    updateAddress() {
        this.submitted = true;
        if (!this.addProfileForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.addProfileForm && this.addProfileForm.getRawValue() && this.addProfileForm.getRawValue().name) ? this.addProfileForm.getRawValue().name : '',
                'email': (this.addProfileForm && this.addProfileForm.getRawValue() && this.addProfileForm.getRawValue().email) ? this.addProfileForm.getRawValue().email : '',
                'contact': (this.addProfileForm && this.addProfileForm.getRawValue() && this.addProfileForm.getRawValue().contact) ? this.addProfileForm.getRawValue().contact : '',
                'address': (this.addProfileForm && this.addProfileForm.getRawValue() && this.addProfileForm.getRawValue().address) ? this.addProfileForm.getRawValue().address : '',
                'city': (this.addProfileForm && this.addProfileForm.getRawValue() && this.addProfileForm.getRawValue().city) ? this.addProfileForm.getRawValue().city : '',
                'pin_code': (this.addProfileForm && this.addProfileForm.getRawValue() && this.addProfileForm.getRawValue().pin_code) ? this.addProfileForm.getRawValue().pin_code : '',
                'state_id': (this.addProfileForm && this.addProfileForm.getRawValue() && this.addProfileForm.getRawValue().state_id) ? this.addProfileForm.getRawValue().state_id : '',
                'gst_no': (this.addProfileForm && this.addProfileForm.getRawValue() && this.addProfileForm.getRawValue().gst_no) ? this.addProfileForm.getRawValue().gst_no : ''
            };
            this.profileService.updateAddress(this.user.userId, params).subscribe(data => {
                if (data) {
                    this.submitted = false;
                }
            });
        }
    }

    updatePassword() {
        this.submitted = true;
        if (!this.profilePasswordForm.valid) {
            return;
        }
        if (this.profilePasswordForm.value.new_password === this.profilePasswordForm.value.confirm_password) {
            if (this.submitted) {
                const params = {
                    'new_password': (this.profilePasswordForm && this.profilePasswordForm.getRawValue() && this.profilePasswordForm.getRawValue().new_password) ? this.profilePasswordForm.getRawValue().new_password : '',
                    'current_password': (this.profilePasswordForm && this.profilePasswordForm.getRawValue() && this.profilePasswordForm.getRawValue().current_password) ? this.profilePasswordForm.getRawValue().current_password : '',
                };
                this.profileService.updatePassword(params).subscribe(data => {
                    this.submitted = false;
                    this.profilePasswordForm.patchValue({
                        'new_password': '',
                        'confirm_password': '',
                        'current_password': ''
                    });
                    this.modalService.dismissAll('');
                    this.responseUpdatePassword = data;
                    this.modalType = 'VERIFY_OTP';
                    this.modalService.open(this.templateRef);
                }, error => {
                    if (error && error['error'] && error['error']['errorDetails']) {
                        this.alertService.showErrors(error['error']['errorDetails']);
                    } else {
                        this.alertService.showErrors('Something went wrong, please try again');
                    }
                    this.submitted = false;
                });
            }
        } else {
            this.submitted = false;
            this.alertService.showErrors('Password and Confirm Password didn\'t match');
        }
    }
    submitOtp() {
        this.submittedOtp = true;
        if (!this.updatePasswordOtpForm.valid) {
            return;
        }
        if (this.submittedOtp) {
            this.profileService.updatePasswordOtp({
                'current_password': this.responseUpdatePassword.current_password,
                'new_password': this.responseUpdatePassword.new_password,
                'otp': this.updatePasswordOtpForm.value.otp,
                'decoded_otp': this.responseUpdatePassword.decoded_otp
            }).subscribe(data => {
                this.modalService.dismissAll('');
                this.submittingOtp = false;
            }, error => {
                if (error && error['error'] && error['error']['errorDetails']) {
                    this.alertService.showErrors(error['error']['errorDetails']);
                } else {
                    this.alertService.showErrors('Something went wrong, please try again');
                }
                this.submittingOtp = false;
            });
        }
    }
}
